module.exports = __webpack_public_path__ + "img/12.688aeb17.png";